import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#work", label: "Work" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, type: "spring", stiffness: 200, damping: 22 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300
        ${scrolled
          ? "backdrop-blur-md bg-void/70 border-b-2 border-witch/40"
          : "bg-transparent"}
      `}
    >
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 flex items-center justify-between h-14">
        <a href="#home" className="flex items-center gap-2 pointer">
          <img
            src="/cauld.png"
            alt=""
            className="pixelated w-8 h-8 drop-shadow-[0_0_8px_rgba(155,61,245,0.8)]"
          />
          <span className="font-display text-[10px] text-bone tracking-tight">
            CAULDRON<span className="text-witch">·</span>DEV
          </span>
        </a>
        <ul className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="block px-3 py-1.5 font-pixel text-sm text-aura hover:text-bone hover:bg-witch/30 border-2 border-transparent hover:border-witch transition-colors pointer"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="#contact"
          className="font-display text-[9px] uppercase px-3 py-1.5 bg-witch text-bone border-2 border-black shadow-[3px_3px_0_0_#000] hover:bg-mystic hover:text-void hover:shadow-[1px_1px_0_0_#000] hover:translate-x-[2px] hover:translate-y-[2px] transition-all pointer"
        >
          Start a project →
        </a>
      </div>
    </motion.nav>
  );
}
